window.mcb.forms.nudetect = (function () {
    const _logger = window.mcb.utilities.createLogger("forms.nudetect");
    var nuDetectReady = false;
    var nuDetectLoading = false;
    var page = 1;
    var sessionId = window.mcb.forms.helpers.generateUUID();
    var _checkReadyStateIntervalSeconds = 1;
    var _checkReadyStateMaxAttempts = 5;
    var _checkReadyStateAttemptCount = 0;

    const getResponse = async function (identity, submitUrlBase, pmd = null, token = null, answer = null) {
        const formData = new FormData();
        formData.append('mc_identity', identity);
        formData.append('mc_sessionId', sessionId);
        formData.append('mc_page', page);
        formData.append('mc_culture', digitalData.page.attributes.language);

        if (answer !== null) {
            formData.append('mc_answer', answer);
        }

        if (pmd !== null) {
            formData.append('mc_pmd', pmd);
        }

        if (token !== null) {
            formData.append('mc_token', token);
        }

        var url = submitUrlBase + '/nudetect';
        const response = await fetch(url, {
            method: 'post',
            body: formData
        });

        if (response.ok !== true) {
            const message = `An error has occured: ${response.status} posting to '${url}'`;
            return {
                success: false,
                error: {
                    message: message,
                    code: response.status
                }
            };
        }

        return await response.json();
    };

    const applyNuDetect = async function (canvas, answer, presentChallenge, onSuccess, onError, formObject) {
        const form = canvas.closest('form');
        let pmd = form.querySelector('input[name="nds-pmd"]');
        let token = form.querySelector('input[name="nucaptcha-token"]');
        const nudetectResponse = await getResponse(formObject.identity, formObject.settings.submitUrlBase, pmd?.value, token?.value, answer);

        canvas.innerHTML = '';
        if (typeof nudetectResponse.returnHtml !== "undefined") {
            presentChallenge(canvas, nudetectResponse.returnHtml, formObject);
        }
        else if (typeof nudetectResponse.error !== "undefined") {
            return onError(canvas, formObject, nudetectResponse.error);
        }
        else {
            if (pmd) {
                pmd.remove();
            }

            if (token) {
                token.remove();
            }

            onSuccess(canvas, formObject, nudetectResponse);
        }
    }

    return _ = {
        load: function (settings) {
            if (settings != null && nuDetectReady === false && nuDetectLoading === false) {
                nuDetectLoading = true;

                _logger.log("Session ID: " + sessionId);

                var baseUrl = settings.baseUrl + "/2.2/w/" + settings.clientId + "/sync/js/";
                (function (w, d, s, u, q, js, fjs, nds) {
                    nds = w.ndsapi || (w.ndsapi = {});
                    nds.config = {
                        q: [],
                        ready: function (cb) {
                            this.q.push(cb)
                        }
                    };

                    nds.config.ready(function () {
                        page = settings.page;

                        nds.setSessionId(sessionId);
                        nds.setPlacement(settings.placement);
                        nds.setPlacementPage(settings.page);
                        _logger.log("NuDetect is Ready");
                    });

                    js = d.createElement(s);
                    js.src = u;
                    js.onload = function () {
                        nds.load(u);

                        window.mcb.forms.nudetect.ready();
                    }

                    fjs = d.getElementsByTagName(s)[0];
                    fjs.parentNode.insertBefore(js, fjs);
                }(window, document, "script", baseUrl));

                window.mcb.forms.nudetect.checkReadyState();
            }
        },
        checkReadyState: function () {
            var postfix = _checkReadyStateAttemptCount == 0 ? 'immediately' : 'after ' + (_checkReadyStateIntervalSeconds * _checkReadyStateAttemptCount) + 's';
            _checkReadyStateAttemptCount++;

            if (window.mcb.forms.nudetect.isReady()) {
                _logger.trace('NuDetect was ready ' + postfix);
            }
            else {
                _logger.trace('NuDetect is not ready ' + postfix);

                window.mcb.tracking.track('GenericError', {
                    identifier: 'NuDetectNotLoaded',
                    value: 'NuDetect is not ready ' + postfix
                });

                if (_checkReadyStateAttemptCount > _checkReadyStateMaxAttempts) {
                    _logger.error('Failed to load NuDetect in a reasonable time!');
                }
                else {
                    setTimeout(window.mcb.forms.nudetect.checkReadyState, _checkReadyStateIntervalSeconds * 1000);
                }
            }
        },
        ready: function () {
            _logger.trace("NuDetect is Loaded");
            nuDetectLoading = false;
            nuDetectReady = typeof window.ndsapi !== "undefined";
        },
        isReady: function () {
            return nuDetectReady;
        },
        getSessionId: function () {
            return sessionId;
        },
        applyNuDetect: applyNuDetect
    };
})();
